module.exports = __webpack_public_path__ + "static/project-jsds-4bbcefae5928ba135c147e753ff3628e.png";